export default {
	LG : {
		Collect:  ['取件','Collect'],
		Confirm:  ['确定','CONFIRM'],
		Forget : ['忘记密码','Forget PIN'],
		IdTit : ['手机号','Handphone'],
		InBound : ['入库','InBound'],
		LastFour:  ['手机号后4位','HP last 4 digits'],
		Login : ['登录','LOGIN'],
		LoginTit :['请输入配送员账号和密码','Please enter your Registered Delivery ID and PIN'],
		Minimum:  ['最短6位','Minimum 6 digits'],
		newPinTit : ['新密码','NEW PIN'],
		OutBound : ['出库','OutBound'],
		OutStockTips : ['第一次取件时，如未开箱，可在5分钟内再次输入取件码取件','If you do not open the door for the first time,you can re-enter the pickup code in 5 minutes.'],
		OutStockStep : ['取件方式：<br/>1、输入手机号后4位+取件短信中6位取件码取件<br/>2、打开取件短信中取件二维码链接扫码取件，15秒内扫码有效','pick-up method:<br/>1.enter the last 4 digit numbers of phone number+6 digit numbers in the pick-up message<br/>2.click on the URL in the pick-up message.A QR code will appear,which can be scanned to open the door.'],
		PinTit : ['密码','Password'],
		PickPassword:  ['取件密码','Collection PIN'],
		PleaseInput:  ['请输入','Please enter'],
		PrevPage:  ['返回','Previous page'],
		Process : ['正在处理','Processing'],
		LoadingTit:  ['请稍后','Please wait'],
		LoadingCont:  ['信息读取中','Loading'],
		Quit:  ['退出登录','Quit'],
		Registration : ['注册','Registration'],
		RetrievePw:  ['密码找回','PIN Reset'],
		RegistAcountTit:  ['配送员账号注册','Register account'],
		RegistAcountTips:  ['扫描二维码进行注册','Scan QR code to Register'],
		SelBoxTit : ['请选择箱格大小','Please Select Box Size'],
		SmsOtp:  ['短信验证码','RECEIVE SMS OTP'],
		VoiceCode:  ['语音验证码','Voice code'],
		verificationCode : ['验证码','SMS OTP'],
		BoxSize : ['箱格尺寸','Locket size'],
		SmallBox : ['小箱','small'],
		MedBox : ['中箱','middle'],
		BigBox : ['大箱','large'],
		MiniBoxRd : ['极小','Mini'],
		SmallBoxRd : ['小箱','Small'],
		MedBoxRd : ['中箱','Medium'],
		BigBoxRd : ['大箱','Large'],
		ExtBoxRd : ['极大','Extremely'],
		BoxNum : ['柜子剩余','Remaining'],
		SelectBox : ['选择箱格大小','Select Size'],
		CheckInBox : ['查询入库记录','QUERY STORAGE RECORDS.'],
		Plscan : ['请进行扫码','Please Scan AWB Code'],
		SubmitList : ['提交入库清单','SUBMIT STORAGE LIST.'],
		Continue : ['继续投递','CONTINUE'],
		CloseScan: ['秒后关闭扫码','second left to stop scan'],
		NoAction: ['扫码期间禁止操作','Forbidden operation during scan'],
		ScanFailure: ['扫码失败','SCAN FAILURE'],
		ManualEntry: ['手动输入','Manual Entry'],
		ExpressNum: ['快递号','AWB Number'],
		ParcelLoading1: ['快递号','Parcel No.'],
		ParcelLoading2: ['正在投递中...','Delivery...'],
		SubmitList2: ['提交入库清单','Submit storage list.'],
		StoRecords: ['入库记录','STORAGE RECORDS'],
		WareBoxNo: ['箱格号','Locker'],
		WareReceNum: ['入库单号','Receipt number'],
		WareStoTime: ['入库时间','Storage time'],
		WareBoxSize: ['箱格尺寸','Locker size'],
		WareNotStorage: ['未入库','Not in storage'],
		WareInStorage: ['已入库','In storage'],
		Cancel: ['取消','CANCEL'],
		SelectAll: ['全选','SELECT ALL'],
		Submit: ['提交','SUBMIT'],
		InventoryList: ['入库清单','Inventory list'],
		OutDoorTips: ['号箱格门已经打开，请取出您的包裹',' is OPEN,please remove your item'],
		sendExpress1: ['入库成功，箱格号为','Box No.'],
		sendExpress2: ['(若未开箱请重新派送)','is open for deposit (if not, reprocess the order)'],
	},
	Fresh : {
		Delivery: ['送件','Delivery'],
		PickUp: ['取件','Pick Up'],
		delivery_direct: ['填写收件人信息投递','Need Registered User’s Detail'],
		delivery_reserve: ['直接扫码投递','SCAN AWB Code & DEPOSIT'],
		tips_delivery_direct: ['未预约，请使用此功能','NO Prior Arrangement'],
		tips_delivery_reserve: ['已预约，请使用此功能','WITH Prior Arrangement'],
		manage_box: ['管理箱格','Locker Management'],
		receiver_phone_no: ['收件人手机号','User’s Tel No'],
		tips_input_receiver_phone: ['请填写收件人信息','Please enter User’s detail'],
		back: ['返回','Previous page'],
	}
}
	// export default {
	// 	LG,
	// }


//////////////////
// WEBPACK FOOTER
// ./static/js/utils/language.js
// module id = null
// module chunks = 